<!--手动发券-->
<template>
  <basic-container>
    <div class="app-header">
      <el-form ref="query" :model="query" size="mini" :inline="true">
        <el-form-item label="优惠名称：" prop="name">
          <el-input v-model="query.name" placeholder="请输入优惠名称" clearable />
        </el-form-item>
        <el-form-item label="发放账号：" prop="phone">
          <el-input v-model="query.phone" placeholder="请输入发放账号" style="width: 179px" />
        </el-form-item>
        <el-form-item label="状态：" prop="state">
          <avue-select
            v-model="query.state"
            placeholder="请选择状态"
            :dic="[
              { label: '待审核', value: 1 },
              { label: '已发放', value: 2 },
              { label: '未通过', value: 3 },
              { label: '发放失败', value: 4 },
              { label: '发放中', value: 5 }
            ]"
          />
        </el-form-item>
        <el-form-item label="发券时间：" prop="dateArr">
          <el-date-picker
            v-model="query.dateArr"
            type="daterange"
            format="yyyy-MM-dd"
            valueFormat="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handelDateArr"
          />
        </el-form-item>

        <el-form-item label="发券人：" prop="createUser">
          <el-input v-model="query.phoneOrName" placeholder="请输入发券人" style="width: 179px" />
        </el-form-item>
        <el-form-item label="隶属公司：" prop="merchantIds">
          <YdMerchantSelector
            v-model="query.merchantIds"
            multiple
            placeholder="请选择隶属公司"
            styles="width: 179px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchChange" :loading="loading">
            筛选
          </el-button>

          <el-button type="danger" icon="el-icon-delete" @click="searchReset" :loading="loading">
            清空
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="crud__container">
      <yd-table
        ref="crud"
        :columns="option.column"
        :loading="loading"
        :data="data"
        :pagination="page"
        @onChange="onTableChange"
        size="mini"
      >
        <template slot="tools">
          <el-button
            type="primary"
            size="mini"
            v-has-permi="['distCountCoupon_send_give']"
            icon="el-icon-circle-plus-outline"
            @click="handleAddOrUpdate"
          >
            发放优惠券
          </el-button>
        </template>
        <template slot-scope="{ row }" slot="name">
          <el-button type="text" size="small" @click="rowDetails(row.id)">
            {{ row.name }}
          </el-button>
        </template>
        <template slot-scope="{ row }" slot="account">
          <span>{{ row.accountNum }} 个</span>
          <!-- <el-popover placement="right" trigger="hover">
            <div v-for="(item, index) of row.account" :key="index">
              <p>{{ index + 1 }}、{{ item }}</p>
            </div>
            <el-button slot="reference" type="text" size="small">
              {{ row.account.length }} 个
            </el-button>
          </el-popover> -->
        </template>
        <template slot-scope="{ row }" slot="menu">
          <span v-if="row.state === 2">-</span>
          <span v-else>
            <el-button
              type="text"
              v-if="row.state === 1"
              size="mini"
              @click.stop="handleAudit(row.id)"
            >
              <el-button type="text" size="mini" v-has-permi="['distCountCoupon_send_examine']">
                通过
              </el-button>
            </el-button>
            <el-button
              type="text"
              v-if="row.state === 1"
              size="mini"
              @click.stop="handleAuditReason(row.id)"
            >
              <el-button type="text" size="mini" v-has-permi="['distCountCoupon_send_examine']">
                不通过
              </el-button>
            </el-button>
            <el-button
              type="text"
              v-if="row.state === 3"
              size="mini"
              @click.stop="handleQueryReason(row.id)"
            >
              查看原因
            </el-button>
          </span>
        </template>
      </yd-table>
    </div>
    <send-coupon-add ref="sendCouponAdd" v-if="sendCouponAddVisible" @refreshDataList="onLoad" />
    <el-drawer
      title="发放详情"
      :visible.sync="visibile"
      :append-to-body="true"
      size="45%"
      @close="closeDetial"
    >
      <div slot="title" class="title-box">发放详情</div>
      <div style="padding-left: 10px">
        <el-descriptions column="1">
          <el-descriptions-item label="状态">{{ info.statesTr }}</el-descriptions-item>
          <el-descriptions-item v-if="info.state === 3" label="不通过原因">
            {{ info.refusedReason }}
          </el-descriptions-item>
          <el-descriptions-item
            label="发放用户"
            :contentStyle="{ maxHeight: '200px', overflow: 'auto' }"
          >
            {{ info.phones ? info.phones.join(',') : '' }}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions column="1" direction="vertical">
          <el-descriptions-item label="优惠券">
            <el-table :data="info.couponDetailVos" border size="mini">
              <el-table-column label="优惠券名称" prop="name" align="center" />
              <el-table-column label="优惠类型" prop="type" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.type === 1 ? '礼包' : '优惠券' }}</div>
                </template>
              </el-table-column>
              <el-table-column label="金额/个" prop="amount" align="center" />
              <el-table-column label="剩余" prop="surplusNum" align="center" />
              <el-table-column label="发放数量" prop="num" align="center" />
            </el-table>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions column="1">
          <el-descriptions-item label="通知方式">
            {{ info.notification || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="通知弹窗" v-if="info.imgUrl">
            <img :src="info.imgUrl" style="width: 160px; height: 180px" />
          </el-descriptions-item>
          <el-descriptions-item label="通知弹窗" v-else>-</el-descriptions-item>
          <el-descriptions-item label="发券原因">{{ info.remark }}</el-descriptions-item>
          <el-descriptions-item label="发券人">{{ info.createUserName }}</el-descriptions-item>
          <el-descriptions-item label="发券时间">{{ info.createTime }}</el-descriptions-item>
          <el-descriptions-item label="审核人">{{ info.auditorName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ info.auditTime || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>

    <el-dialog
      :title="nInfo.type === 'N' ? '审核不通过' : '查看原因'"
      :visible.sync="nVisible"
      width="55%"
      :append-to-body="true"
    >
      <div v-if="nInfo.type === 'N'">
        <el-form :model="nInfo" size="small" label-width="99px">
          <el-form-item label="不通过的原因">
            <el-input
              type="textarea"
              v-model="nInfo.refusedReason"
              placeholder="请输入不通过原因"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="info" @click="nVisible = !nVisible">取消</el-button>
            <el-button type="primary" @click="handleSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="nInfo.type === 'ND'">
        <el-form>
          <el-form-item label="状态:">{{ ndInfo.state === 3 ? '审核未通过' : '' }}</el-form-item>
          <el-form-item label="不通过原因:">{{ ndInfo.refusedReason }}</el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
  import SendCouponAdd from '../components/sendcoupon/send-coupon-add'
  import {
    sendCouponPage,
    detaSendCoupon,
    activityCouponDetail,
    auditCouponp
  } from '@/api/marketing/activities-api'
  export default {
    name: 'sendCoupon',
    components: {
      SendCouponAdd
    },
    data() {
      return {
        loading: true,
        sendCouponAddVisible: false,
        visibile: false,
        nVisible: false,
        query: {
          name: undefined,
          phone: undefined,
          state: undefined,
          merchantIds: [],
          dateArr: [],
          startTime: undefined,
          endTime: undefined
        },
        data: [],
        page: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        option: {
          border: true,
          selection: true,
          tip: false,
          stripe: true,
          index: false,
          indexLabel: '序号',
          menuWidth: 350,
          simplePage: false,
          align: 'center',
          refreshBtn: true,
          searchSize: 'mini',
          addBtn: false,
          editBtn: false,
          delBtn: false,
          viewBtn: false,
          menu: false,
          column: [
            {
              label: '名称',
              align: 'center',
              prop: 'name',
              width: 200
            },
            {
              label: '优惠金额',
              align: 'center',
              prop: 'discountsMoney',
              width: 100
            },
            {
              label: '隶属公司',
              align: 'center',
              prop: 'merchantName'
            },
            {
              label: '发放账号',
              align: 'center',
              prop: 'account',
              width: 120
            },
            // {
            //   label: '创建时间',
            //   align: 'center',
            //   width: 180,
            //   prop: 'createTime'
            // },
            {
              label: '发券人',
              prop: 'createUserName',
              align: 'center',
              width: 120
            },
            {
              label: '发券原因',
              prop: 'remark',
              align: 'center'
            },
            {
              label: '审核人',
              align: 'center',
              prop: 'auditorName',
              width: 120
            },
            {
              label: '审核时间',
              align: 'center',
              width: 160,
              prop: 'auditTime'
            },
            {
              label: '状态',
              align: 'center',
              width: 80,
              prop: 'state',
              formatter: ({ row }) => {
                if (!row.state) {
                  return '-'
                }
                if (row.state === 1) {
                  return '待审核'
                }
                if (row.state === 2) {
                  return '已发放'
                }
                if (row.state === 3) {
                  return '未通过'
                }
                if (row.state === 4) {
                  return '发放失败'
                }
                if (row.state === 5) {
                  return '发放中'
                }
              }
            },
            {
              label: '操作',
              align: 'center',
              width: 180,
              prop: 'menu'
            }
          ]
        },
        info: {},
        nInfo: {
          type: 'N'
        },
        ndInfo: {}
      }
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.page.current = current
        this.page.pageSize = pageSize
        this.onLoad()
      },
      rowDetails(id) {
        this.$nextTick(() => {
          this.visibile = true
          activityCouponDetail(id).then((resp) => {
            this.info = resp.data
          })
        })
      },
      closeDetial() {
        this.visibile = false
        this.info = {}
      },
      searchChange() {
        this.page.current = 1
        this.onLoad(this.page, this.query)
      },
      searchReset() {
        this.query = {
          name: undefined,
          phone: undefined,
          state: undefined,
          merchantIds: [],
          dateArr: [],
          startTime: undefined,
          endTime: undefined
        }
        this.onLoad(this.page)
      },
      onLoad(page, params = {}) {
        this.loading = true
        const aonData = {
          current: this.page.current,
          size: this.page.pageSize,
          ...this.query
        }
        sendCouponPage(Object.assign(aonData, params)).then((resp) => {
          this.data = resp.data.records
          this.page.total = resp.data.total
          this.loading = false
        })
      },
      handleAddOrUpdate() {
        this.sendCouponAddVisible = true
        this.$nextTick(() => {
          this.$refs.sendCouponAdd.init()
        })
      },
      handleAudit(id) {
        const adonData = {
          id,
          state: 2
        }
        this.$confirm('确定审核通过吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            return auditCouponp(adonData)
          })
          .then((resp) => {
            this.onLoad()
            this.$message({
              type: 'success',
              message: resp.msg
            })
          })
      },
      handleAuditReason(id) {
        this.$nextTick(() => {
          this.nInfo.type = 'N'
          this.nInfo.id = id
          this.nVisible = true
        })
      },
      handleQueryReason(id) {
        this.$nextTick(() => {
          this.nInfo.type = 'ND'
          this.nVisible = true
          detaSendCoupon(id).then((resp) => {
            this.ndInfo = resp.data
          })
        })
      },
      handleSubmit() {
        const dd = {
          id: this.nInfo.id,
          refusedReason: this.nInfo.refusedReason,
          state: 3
        }
        auditCouponp(dd).then((resp) => {
          if (resp.code === 0) {
            this.nVisible = false
            this.onLoad(this.page)
          }
        })
      },
      // 发券时间值改变事件
      handelDateArr(val) {
        if (val && val.length === 2) {
          this.query.startTime = val[0]
          this.query.endTime = val[1]
        } else {
          this.query.startTime = ''
          this.query.endTime = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
</style>
